import { IonSelect, IonSelectOption } from '@ionic/react'
import React from 'react'
import styled from 'styled-components'
import { PARAM_SORT } from '../../../common'

type Props = {
  setSortType: (sortType: PARAM_SORT) => void
  sortList: { type: string; title: string }[]
}

export const SelectSort: React.FC<Props> = ({ setSortType, sortList }) => {
  return (
    <IonSelectContainer>
      <IonSelect
        aria-label="sort"
        justify="end"
        placeholder="기본 정렬"
        onIonChange={(e) => setSortType(e.detail.value)}
        mode={'ios'}
        interfaceOptions={{
          header: '정렬',
          mode: 'ios',
          cssClass: 'cardo-alert-one-btn',
        }}
        okText={'적용'}
      >
        {sortList.map((d, i) => (
          <IonSelectOption key={i} value={d.type}>
            {d.title}
          </IonSelectOption>
        ))}
      </IonSelect>
    </IonSelectContainer>
  )
}

const IonSelectContainer = styled.div`
  font-size: 13px;
  display: flex;
  justify-content: end;
  padding: 5px 0;
  ion-select {
    --placeholder-color: var(--ion-color-primary_dark);
    width: 100px;
  }
  ion-select::part(text) {
    color: var(--ion-color-primary_dark);
  }
`
